import { createTheme } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    primary: {
      main: '#FFF',
    },
    secondary: {
      main: '#2ecc71',
    },
    background: {
      default: '#f4f6f8', // Set to solid color (gradient is handled below)
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif, Work Sans',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '0.02em',
      color: '#fff',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
      lineHeight: 1.3,
      color: '#fff',
      textAlign: 'center',
      textTransform: 'uppercase',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: 'white',
      textAlign: 'center',
    },
    h5: {
      fontSize: '2.1875rem', // Adjusted to match Material-UI scaling
      lineHeight: '2.625rem',
      fontWeight: '700',
      color: '#0A3551',
    },
    h6: {
      color: '#0A3551',
      textAlign: 'center',
      fontSize: '1.4375rem',
      fontWeight: '700',
      lineHeight: 'normal',
      textTransform: 'uppercase',
    },
    subtitle1: {
      color: '#0A3551',
    },
    body1: {
      color: '#000000',
      fontSize: '1rem',
      fontWeight: '600',
    },
    body2: {
      color: '#000',
      fontWeight: '500',
      fontSize: '0.875rem',
    },
  },
  spacing: 8, // default spacing unit
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
        },
        containedPrimary: {
          background: '#03395A',
          borderRadius: '50px',
          width: '50%',
          padding: '10px',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#03395ae0',
          },
        },
        outlinedPrimary: {
          backgroundColor: 'transparent',
          // color: '#556cd6',
          '&:hover': {
            backgroundColor: 'rgba(85, 108, 214, 0.04)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'black',
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#0274bc',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#C2CDD4',
          },
          '& .MuiSvgIcon-root': {
            borderRadius: '50%',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
        },
      },
    },
  },
});
export { theme };
